/**
 * Composant SaveModeleDialog pour la page Satisfaction
 * Boîte de dialogue pour nommer et sauvegarder un modèle de questionnaire
 */

import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../components/ui/dialog';

export const SaveModeleDialog = ({
  open,
  onOpenChange,
  modeleName,
  setModeleName,
  customQuestions,
  onConfirm
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="save-modele-dialog">
        <DialogHeader>
          <DialogTitle>Enregistrer le modèle</DialogTitle>
          <DialogDescription>
            Donnez un nom à votre modèle de questionnaire personnalisé
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4">
          <div>
            <Label>Nom du modèle</Label>
            <Input
              value={modeleName}
              onChange={(e) => setModeleName(e.target.value)}
              placeholder="Ex: Satisfaction fin de stage..."
              autoFocus
              data-testid="input-modele-name"
            />
          </div>
          
          <div className="p-3 bg-slate-50 rounded-lg">
            <p className="text-xs text-slate-500 mb-2">Ce modèle contiendra {customQuestions.length} question(s) :</p>
            <ul className="text-xs text-slate-600 space-y-1">
              {customQuestions.slice(0, 3).map((q, idx) => (
                <li key={idx} className="truncate">• {q.texte}</li>
              ))}
              {customQuestions.length > 3 && (
                <li className="text-slate-400">... et {customQuestions.length - 3} autres</li>
              )}
            </ul>
          </div>
        </div>
        
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Annuler</Button>
          <Button onClick={onConfirm} className="bg-green-600 hover:bg-green-700" data-testid="btn-confirm-save-modele">
            Enregistrer
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default SaveModeleDialog;
